import React, { useEffect} from 'react';
import {useHistory} from 'react-router-dom';
import '../style/parallax-star.css';
import { useLanguage } from '../i18n/LanguageContext';

export default function Auth() {
  let history = useHistory();
  const { t } = useLanguage();

  useEffect(()=>{
    setTimeout(()=>{
      if(localStorage.getItem("accessToken")){
        history.replace("/home");
      }else{
        history.replace("/login");
      }
    }, 500);
  }, [history]);

  return (
    <div className="parallax-back">
      <div className="App">
        <div className="App-Auth">
          <header style={{zIndex: 20}}>
            <p>Cyclone™</p>
            {t('auth.authenticating')}
          </header>
        </div>
      </div>
      <div id='stars'></div>
      <div id='stars2'></div>
      <div id='stars3'></div>
    </div>
  );
}
